import Cookies from 'js-cookie'
import Config from '@/settings'

const TokenKey = Config.TokenKey
const UserId = Config.UserId
const UserName = Config.UserName

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getUserId() {
  return Cookies.get(UserId)
}

export function getUserName() {
  return Cookies.get(UserName)
}

export function setToken(token, rememberMe) {
  if (rememberMe) {
    return Cookies.set(TokenKey, token, { expires: Config.tokenCookieExpires })
  } else return Cookies.set(TokenKey, token)
}

export function setUserId(userId) {
  return Cookies.set(UserId, userId)
}

export function setUserName(userName) {
  return Cookies.set(UserName, userName)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeUserId() {
  return Cookies.remove(UserId)
}
